/**
 * Tiny plain-English explainer for how the headline portfolio numbers
 * are calculated. Triggered by a small (i) icon next to the "Total
 * Return" card on the Performance tab. Zero jargon, two paragraphs.
 */
import React from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export default function ReturnMethodologyInfo() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="How is this calculated?"
          className="inline-flex items-center justify-center text-slate-400 hover:text-slate-700 transition-colors p-0.5 rounded-full -ml-0.5"
          data-testid="return-methodology-info"
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom" align="start"
        className="w-80 text-sm leading-relaxed"
        data-testid="return-methodology-popover"
      >
        <div className="font-semibold text-slate-900 mb-2">
          How your return is calculated
        </div>
        <p className="text-slate-700 mb-3">
          Your <strong>return</strong> is simply what your investments are
          worth today minus what you originally paid for them.
          Straightforward and unchanged.
        </p>
        <p className="text-slate-700">
          The <strong>percentages</strong> (both overall and annualized) use{' '}
          <em>Time-Weighted Return</em> — the same method professional
          investment managers use. It strips out the effect of when you
          added or withdrew money, so you can compare your performance
          fairly against any market index. In plain English: if you added
          a large sum half-way through the year, this method gives you
          credit only for what your investments actually earned, not for
          the larger pile of money sitting in your account.
        </p>
      </PopoverContent>
    </Popover>
  );
}
